//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formPage from "./form";

export default {
  components: { formPage },
  props: [],
  data() {
    return {
      tableData: [],
      pgData: {},

      dialogVisible: false,
      dialogTitle: "",

      dialogVisible_branch: false,
      dialogTitle_branch: "",

      fileguid: "",

      formSearch: {
        rowguid: ""
      },
      uploadid: ""
    };
  },
  watch: {
    dialogVisible(n, o) {
      !n && this.reloadHandler();
    },
    dialogVisible_branch(n, o) {
      !n && this.reloadHandler();
    }
  },
  methods: {
    addHandler() {
      sessionStorage.setItem("id", "");
      this.goto("./form");
    },
    editHandler(row) {
      sessionStorage.setItem("id", row.id);
      this.goto("./form");
    },
    copyHandler(row) {
      var that = this;
      sessionStorage.setItem("id", "");
      this.$ajax({
        type: "get",
        url: that.getStore("bankguart") + "/gua_order/" + row.id + "/copy",
        data: {},
        callback: function(data, res) {
          that.$router.push({ path: "./form", query: data });
        },
        error: function(data, res) {
          console.log(data);
        }
      });
    },
    detailHandler(row) {
      sessionStorage.setItem("id", row.id);
      this.goto("./detail");
    },
    addBranch(row) {
      this.dialogTitle_branch = "添加支行";
      this.formSearch = {
        rowguid: "",
        bankid: row.rowguid,
        bankname: row.bankname
      };
      this.dialogVisible_branch = true;
    },
    delHandler(row) {
      var that = this;
      this.$ajax({
        type: "delete",
        url: that.getStore("bankguart") + "/gua_order/" + row.id,
        data: {},
        callback: function(data, res) {
          that.$notify({
            title: "成功",
            message: "删除成功",
            type: "success"
          });
          that.reloadHandler();
        },
        error: function(data, res) {
          console.log(data);
        }
      });
    },
    reloadHandler() {
      this.$refs.page.reload();
    },
    submitHandler(row) {
      var that = this;
      this.$confirm("确认提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          that.$ajax({
            type: "post",
            url:
              that.getStore("bankguart") + "/gua_order/" + row.id + "/submit",
            data: {},
            callback: function(data, res) {
              that.$notify({
                title: "成功",
                message: "提交成功",
                type: "success"
              });
              that.reloadHandler();
            },
            error: function(data, res) {
              console.log(data);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },
    GenNonDuplicateID() {
      //获取随机字符串
      let idStr = Date.now().toString(36);
      idStr += Math.random()
        .toString(36)
        .substr(3);
      return idStr;
    }
  },
  mounted: function() {
    this.fileguid = this.GenNonDuplicateID();
  }
};
